import { LegalClientBeneficiaryEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { CountryRiskField } from 'modules/client/common/feature';

import { LegalClientBeneficiaryMainInfoType } from '../types';

const getLegalClientBeneficiaryMainInfoForGlobal = (
  client: LegalClientBeneficiaryEntity
): LegalClientBeneficiaryMainInfoType => ({
  citizenship: client.citizenships?.[0],
  email: client.email,
  country: client.residentialAddress?.country,
  countryRiskField: CountryRiskField.ResidentialAddress,
  capitalParticipationPercentage:
    (client.controlOver?.directCapitalParticipationPercentage ?? 0) +
    (client.controlOver?.indirectCapitalParticipationPercentage ?? 0),
});

const getLegalClientBeneficiaryMainInfoForFinance = (
  client: LegalClientBeneficiaryEntity
): LegalClientBeneficiaryMainInfoType => ({
  email: client.email,
  country: client.registrationAddress?.country,
  countryRiskField: CountryRiskField.RegistrationAddress,
  capitalParticipationPercentage:
    (client.controlOver?.directCapitalParticipationPercentage ?? 0) +
    (client.controlOver?.indirectCapitalParticipationPercentage ?? 0),
});

export const getLegalClientBeneficiaryMainInfo = (
  client: LegalClientBeneficiaryEntity
): LegalClientBeneficiaryMainInfoType | undefined => {
  if (isGlobalProject()) {
    return getLegalClientBeneficiaryMainInfoForGlobal(client);
  }
  if (isFinanceProject()) {
    return getLegalClientBeneficiaryMainInfoForFinance(client);
  }

  return undefined;
};
